import cn from 'classnames';
import React, {useEffect, useRef} from 'react';
import '../VideoStream/VideoStream.scss';
import Hls from 'hls.js';
import {VideoMonitor} from './VideoStreamMonitor';

export type VideoStreamMetadataProps = {
  width: number;
  height: number;
  clientWidth: number;
  clientHeight: number;
  duration: number;
};

type VideoStreamProps = {
  className?: string;
  hlsRef?: Hls | null;
  streamReady: boolean;
  streamConnected: boolean;
  onLoadedMetadata?: (args: VideoStreamMetadataProps) => void;
  onLoadedVideoControl?: (ref: HTMLVideoElement) => void;
  monitor?: VideoMonitor;
};

export const VideoStream = ({
  className,
  hlsRef,
  streamReady,
  streamConnected,
  onLoadedMetadata = () => {},
  onLoadedVideoControl = _ => {},
  monitor,
}: VideoStreamProps) => {
  const remoteVideoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    if (remoteVideoRef.current) {
      onLoadedVideoControl(remoteVideoRef.current);
    }
  }, [onLoadedVideoControl]);

  useEffect(() => {
    if (remoteVideoRef.current && hlsRef) {
      if (streamReady) {
        remoteVideoRef.current.play();
        if (monitor) {
          monitor.video = remoteVideoRef.current;
        }
      } else if (streamConnected) {
        hlsRef.attachMedia(remoteVideoRef.current);
      }
    }
  }, [hlsRef, streamConnected, streamReady, monitor]);

  const onLoadedMetadataLocal = (e: any) => {
    const video = remoteVideoRef.current;
    if (video) {
      onLoadedMetadata({
        width: video.videoWidth,
        height: video.videoHeight,
        clientWidth: video.clientWidth,
        clientHeight: video.clientHeight,
        duration: video.duration,
      });
    }
  };

  return (
    <>
      {className === 'ONNX' && (
        <>
          <video
            style={{backgroundColor: '#000'}}
            ref={remoteVideoRef}
            autoPlay={true}
            // Safari blocks autoplay videos that are not muted by default
            muted={true}
            playsInline={true}
            controls={false}
            onLoadedMetadata={onLoadedMetadataLocal}
          ></video>
          <canvas></canvas>
        </>
      )}
      {className !== 'ONNX' && (
        <div className={cn('video-stream', className)}>
          <div className="video-stream__body">
            <div className="video-stream__status" id="video-stream-status"></div>
            <div className="video-stream__video-container">
              <video
                className="video-stream__remote"
                ref={remoteVideoRef}
                autoPlay={true}
                // Safari blocks autoplay videos that are not muted by default
                muted={true}
                playsInline={true}
                controls={false}
                onLoadedMetadata={onLoadedMetadataLocal}
              ></video>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
